/**
 * Grupos do menu "Adicionar bloco". `slots` é do core; os outros são
 * nossos e entram em `groupBlocksOrder` (ver `./index.ts`).
 */
export const GROUP_HOME = 'home';
export const GROUP_SUBHOME = 'subhome';
export const GROUP_SERVICOS = 'servicos';
export const GROUP_SIDE_MENU = 'sideMenu';
export const GROUP_SLOTS = 'slots';

export const LOCAL_GROUPS = [
  { id: GROUP_SIDE_MENU, title: 'Side menu' },
  { id: GROUP_HOME, title: 'Home' },
  { id: GROUP_SUBHOME, title: 'Sub-home' },
  { id: GROUP_SERVICOS, title: 'Serviços' },
];
